<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <div class="d-flex justify-content-between">
                    <h3
                      class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                    >
                      Nuevo Banco de CILARA
                    </h3>
                    <div class="">
                      <button
                        class="mt-2 btn-sm bg-primary text-white font-weight-normal border btn-outline-primary h5 btn d-flex flex-nowrap align-items-center"
                        @click.prevent="returnUrl"
                      >
                        <i class="bi bi-arrow-left mr-1"></i>
                        Volver
                      </button>
                    </div>
                  </div>
                  <form @submit.prevent="saveElement">
                    <div class="row">
                      <div class="col-12 px-0">
                        <div class="row">
                          <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0 py-0">
                            <label for="">Banco</label>
                            <input
                              type="text"
                              placeholder="Banco"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.bank_name"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0 py-0">
                            <label for="">Número de cuenta</label>
                            <input
                              type="text"
                              placeholder="Número de cuenta"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.account_number"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0 py-0">
                            <label for="">RIF</label>
                            <input
                              type="text"
                              placeholder="RIF"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.rif"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0 py-0">
                            <label for="">Titular de la cuenta</label>
                            <input
                              type="text"
                              placeholder="Titular de la cuenta"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.account_titular"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pr-md-2 pl-0 pr-0 py-0">
                            <label for="">Tipo de Banco</label>
                            <Multiselect
                              v-model="form.id_type_bank"
                              :options="bankTypes"
                              label="name"
                              placeholder="Seleccione el tipo de banco"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0 py-0">
                            <label for="">Correo</label>
                            <input
                              type="email"
                              placeholder="Correo"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.email"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pr-md-2 pl-0 pr-0 py-0">
                            <label for="">Teléfono</label>
                            <input
                              type="text"
                              placeholder="Teléfono"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.phone"
                              required
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="d-flex justify-content-end w-100 mt-2">
                        <button
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                          type="submit"
                        >
                          Guardar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  components: {
    Multiselect
  },
  name: 'app',
  data() {
    return {
      form: {
        bank_name: '',
        account_number: '',
        rif: '',
        account_titular: '',
        id_type_bank: null,
        email: '',
        phone: ''
      },
      bankTypes: []
    }
  },
  methods: {
    ...mapActions(['createData', 'getData']),

    async loadBankTypes() {
      try {
        const form = {
          url: 'type_bank/all',
          params: { active: 1 }
        }
        const response = await this.getData(form)
        if (response.code === 200) {
          this.bankTypes = response.data.map((item) => ({
            id: item.id,
            name: item.name
          }))
        }
      } catch (error) {
        console.error('Error al cargar tipos de banco:', error)
      }
    },

    saveElement() {
      if (
        !this.form.bank_name ||
        !this.form.account_number ||
        !this.form.rif ||
        !this.form.account_titular ||
        !this.form.id_type_bank ||
        !this.form.phone
      ) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete todos los campos para continuar.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }

      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar este banco?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,

        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, Guardar'
      }).then((result) => {
        if (result.isConfirmed) {
          const formData = new FormData()
          formData.append('bank_name', this.form.bank_name)
          formData.append('account_number', this.form.account_number)
          formData.append('rif', this.form.rif)
          formData.append('email', this.form.email)
          formData.append('account_titular', this.form.account_titular)
          formData.append('id_type_bank', this.form.id_type_bank.id)
          formData.append('phone', this.form.phone)

          const form = {
            url: 'cilara_bank/save',
            data: formData
          }

          this.createData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Banco guardado correctamente',
                  icon: 'success',

                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  this.returnUrl()
                })
              } else if (response.code === 409) {
                Swal.fire({
                  title: 'Error',
                  text: 'Ya existe un banco con este nombre.',
                  icon: 'error',

                  confirmButtonText: 'Aceptar'
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',

                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },

    returnUrl() {
      this.$router.go(-1)
    }
  },
  mounted() {
    this.loadBankTypes()
  }
}
</script>

<style scoped></style>
